import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Auth0ProviderWithConfig from './auth/Auth0ProviderWithConfig';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Auth0ProviderWithConfig>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Auth0ProviderWithConfig>
  </React.StrictMode>
);
